import React from 'react';
import ReactDOM from 'react-dom';

import { STORE_SECTION_PRELOADER_CONTAINER } from '../../../components/Blocks/Store/StoreSection/data-ids';
import { Preloader } from '../../../components/Blocks/Store/StoreSection/Preloader';

export const renderSectionPreloader = (section: Element) => {
  if (!section) {
    throw new Error(
      "Not possible to add store section preloader when it doesn't exist"
    );
  }
  const preloaderContainer = section.querySelector(
    `[data-id="${STORE_SECTION_PRELOADER_CONTAINER}"]`
  );
  ReactDOM.render(<Preloader />, preloaderContainer);
};

export const unmountSectionPreloader = (section) => {
  if (!section) {
    throw new Error(
      "Not possible to remove store section preloader when it doesn't exist"
    );
  }
  const preloaderContainer = section.querySelector(
    `[data-id="${STORE_SECTION_PRELOADER_CONTAINER}"]`
  );
  ReactDOM.unmountComponentAtNode(preloaderContainer);
};
